import { render, staticRenderFns } from "./SplitGood.vue?vue&type=template&id=233034a8&scoped=true"
import script from "./SplitGood.vue?vue&type=script&lang=js"
export * from "./SplitGood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233034a8",
  null
  
)

export default component.exports